import { CompareCarQuoteParams } from '@apis/CarQuoteApi';
import { getRoute } from '@utils/route';

export type CarQuoteComparePageParams = CompareCarQuoteParams;

export const CAR_QUOTE_COMPARE_PAGE_URL = '/car-insurance-quote-compare';

export const routeCarQuoteComparePage = (searchParams: CarQuoteComparePageParams) => getRoute(CAR_QUOTE_COMPARE_PAGE_URL, { searchParams });
